import type { API } from 'chessboard/api/config/types';
import { Game } from 'chessboard/model/game/types';
import { isClaimableDraw } from 'chessboard/model/jce/is-claimable-draw';
import { isJCEWin } from 'chessboard/model/jce/is-jce-win';

/**
 * Create the getCalculatedResult method.
 */
export function createGetCalculatedResult(context: API.Context) {
  /**
   * Calculate the result, according to JCE and the game options.
   */
  return function getCalculatedResult(): Game.Results {
    const { api, game } = context;

    let result = Game.Results.None;

    const isClaimable = isClaimableDraw(game);

    if (isJCEWin(game)) {
      result = game.turn() === Game.ColorsAsNumbers.Black ? Game.Results.White : Game.Results.Black;
    } else if ((isClaimable && api.getOptions().autoClaimDraw) || (!isClaimable && game.inDraw())) {
      result = Game.Results.Draw;
    }

    return result;
  };
}
